module.exports = __webpack_public_path__ + "img/SES_1013257.72ab5f29.jpg";